<div class="article-container">
  <div class="article-header">
    <div class="article-title">{{article.title | uppercase}}</div>
    <div class="article-date">{{article.date}}</div>
  </div>
  <div class="article-body">
    <div [innerHtml]="article.body"></div>
  </div>
</div>
